/** Bundled Image Assets have different data structures depending on the build context
 * - Under webpack, they are compiled to a string representing the src of the image
 * - Under next.js, they are compiled to the object representation
 */
export type BundledImageAsset =
  | string
  | {
      src: string;
      width: number;
      height: number;
    };

export const getBundledImageAssetProps = (
  asset: BundledImageAsset,
): React.ComponentProps<'img'> => {
  if (typeof asset === 'string') {
    return {src: asset};
  }
  return {
    src: asset.src,
    width: asset.width,
    height: asset.height,
  };
};
